// Green Theme Configuration
const guiColors = {
    // Motion (Green version)
    'motion-primary': '#78C257', // Vert équilibré
    'motion-primary-transparent': '#78C257E6',
    'motion-tertiary': '#5A9141', // Vert légèrement plus soutenu pour la profondeur

    // Looks (Green version)
    'looks-secondary': '#78C257',
    'looks-transparent': '#78C25759',
    'looks-light-transparent': '#78C25726',
    'looks-secondary-dark': 'hsla(105, 35%, 35%, 1)', // Vert olive profond

    // Extensions (Green version)
    'extensions-primary': 'hsla(105, 40%, 55%, 1)',
    'extensions-tertiary': 'hsla(105, 40%, 30%, 1)',
    'extensions-transparent': 'hsla(105, 40%, 55%, 0.35)',
    'extensions-light': 'hsla(105, 60%, 90%, 1)',

    // Drop Highlight
    'drop-highlight': '#C8E6C9' // Vert très pâle pour le surlignage
};

const blockColors = {
    checkboxActiveBackground: '#78C257',
    checkboxActiveBorder: '#5A9141'
};

export {
    guiColors,
    blockColors
};
